import { render, staticRenderFns } from "./TipoHistorico.vue?vue&type=template&id=3fd9e9d3&scoped=true"
import script from "./TipoHistorico.vue?vue&type=script&lang=js"
export * from "./TipoHistorico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd9e9d3",
  null
  
)

export default component.exports